import axios, { AxiosError, AxiosResponse, Method } from 'axios';

const httpGET = 'GET';
const httpPOST = 'POST';
const httpPUT = 'PUT';
const httpPATCH = 'PATCH';
const httpDELETE = 'DELETE';

type CustomResponseConfig = {
  responseType?: any;
  includeFullResponse?: boolean;
};

export default class RestUtilities {
  public get<T>(endpoint: string): Promise<T> {
    return this.request<T>(httpGET, endpoint);
  }

  public post<T>(
    endpoint: string,
    data: unknown,
    responseConfig?: CustomResponseConfig
  ): Promise<T> {
    return this.request<T>(httpPOST, endpoint, data, responseConfig);
  }

  public put<T>(endpoint: string, data: unknown): Promise<T> {
    return this.request<T>(httpPUT, endpoint, data);
  }

  public patch<T>(endpoint: string, data?: unknown): Promise<T> {
    return this.request<T>(httpPATCH, endpoint, data);
  }

  public delete<T>(endpoint: string, data?: unknown): Promise<T> {
    return this.request<T>(httpDELETE, endpoint, data);
  }

  private request<T>(
    method: Method,
    endpoint: string,
    data?: unknown,
    responseConfig?: CustomResponseConfig
  ): Promise<T> {
    const body = data;

    let requestConfig;
    if (responseConfig && responseConfig.responseType) {
      requestConfig = {
        method,
        data: body,
        withCredentials: true,
        responseType: responseConfig.responseType,
      };
    } else {
      requestConfig = {
        method,
        data: body,
        withCredentials: true,
      };
    }

    return this.getPromise(endpoint, requestConfig);
  }

  private getPromise<T>(url: string, requestConfig: object): Promise<T> {
    return new Promise((resolve, reject) => {
      return axios(url, requestConfig)
        .then((response: AxiosResponse<T>) => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          console.error('GS::ServerError', error);
          reject(error);
        });
    });
  }
}
